/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState, useRef } from "react";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import { WereHouseRoute } from "../../were-house.routes";
import { columns } from "./components/columns";
import { GridRowModel } from "@mui/x-data-grid-pro";
import { useDispatch } from "react-redux";
import {
  getInventoryStatusBannedItemsListingAction,
  getInventoryStatusDetailsDistributionAction,
  getInventoryStatusListingAction,
} from "src/app-redux/warehouse/actions/wareHouseActions";
import { loader as loading } from "src/app-redux/warehouse/wareHouseSlice";
import { useAppSelector } from "src/app-redux/hooks";
import { useFormik } from "formik";
import { Box, FormControlLabel, Grid, Switch } from "@material-ui/core";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { WerehouseLevel2Table } from "./components/werehouseLevel2Table";
import CommonDialog from "src/components/AlertDialog/CommonDialog";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import moment from "moment";
import "moment-timezone";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonTextFieldMonthYear from "src/components/CommonTextFieldForDate/CommonTextFieldMonthYear";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { yearDate } from "src/common/utils/app.dropdowns";

const rows: any = [
  { typeOfCargo: "item1", totalWeight: 342 },
  { typeOfCargo: "item2", totalWeight: 839 },
  { typeOfCargo: "item3", totalWeight: 563 },
  { typeOfCargo: "item4", totalWeight: 9374 },
];

export function InventoryHistory() {
  const dispatch = useDispatch();
  const loader: any = useAppSelector(loading);

  const moduleName = WereHouseRoute.title;
  const pageHeading = WereHouseRoute.subRoutes ? WereHouseRoute.subRoutes[3].title : "Page Title";

  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);
  const [isOpenDailog, setIsOpenDailog] = useState(false);
  const [title, setTitle] = useState("");
  const dailyDatePickerRef: any = useRef(null);
  const monthlyDatePickerRef: any = useRef(null);

  const [resetHandler, setResetHandler] = useState(false);
  const getYear = new Date().getFullYear();
  const formik = useFormik({
    initialValues: {
      bannedItems: false,
      daily: moment(new Date(new Date().setDate(new Date().getDate())).setHours(0, 0)).format(
        "YYYY-MM-DD"
      ),
      monthly: moment(new Date(new Date())).format("MM/YYYY"),
      yearly: getYear,
    },
    onSubmit: () => {
      // alert(JSON.stringify(values, null, 2));
    },
  });
  const { setValues } = formik;

  const addSerialNumber = async (rows: any) => {
    const transformedData = await rows?.map((row: any, index: number) => ({
      ...row,
      id: index,
      sNo: index + 1,
    }));
    return transformedData;
  };

  const getInventoryStatus = async () => {
    const date = {
      daily: moment(new Date(formik.values.daily)).format("MM-DD-YYYY"),
      yearly: moment(new Date(`01/01/${formik.values.yearly}`)).format("DD-MM-YYYY"),
      monthly: moment(new Date(`01/${formik.values.monthly}`)).format("DD-MM-YYYY"),
    };
    const results: any = await dispatch(getInventoryStatusListingAction(date));
    const rows = await results?.payload?.inventryStatusLists;
    const transformedRows: any = await addSerialNumber(rows);
    setGridRecord(transformedRows);
  };
  const getInventoryStatusBannedItems = async () => {
    const date = {
      daily: moment(new Date(formik.values.daily)).format("MM-DD-YYYY"),
      yearly: moment(new Date(`01/01/${formik.values.yearly}`)).format("DD-MM-YYYY"),
      monthly: moment(new Date(`01/${formik.values.monthly}`)).format("DD-MM-YYYY"),
    };
    const results: any = await dispatch(getInventoryStatusBannedItemsListingAction(date));
    const rows = await results?.payload?.inventryBannedItemLists;
    const transformedRows: any = await addSerialNumber(rows);
    setGridRecord(transformedRows);
  };

  useEffect(() => {
    handleSearch();
    setResetHandler(false);
  }, [formik.values.bannedItems, resetHandler]);

  const level2DataHandler = async (
    unitId: any,
    inventoryNameId: any,
    filterBy: any,
    filterByDate: any
  ) => {
    await dispatch(
      getInventoryStatusDetailsDistributionAction({
        unitId: unitId,
        inventoryNameId: inventoryNameId,
        filterBy: filterBy,
        filterDate: filterByDate,
      })
    );
    toggleDialog();
  };

  useEffect(() => {
    if (rows.length) {
      const transformedColumns: any = columns.map((column: any) =>
        column.accessorKey === "daily"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const value = `${row.original.daily ? row.original.daily : "0"}`;
                const weightUnit = ` ${
                  row.original.weightUnit
                    ? row.original.weightUnit == "Cubic meter"
                      ? "m³"
                      : row.original.weightUnit
                    : "KG"
                }`;
                return (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      level2DataHandler(
                        row.original.unitId,
                        row.original.inventoryNameId,
                        1,
                        row.original.dailyDate
                      );
                      setTitle("Today");
                      return;
                    }}
                  >{`${value} ${weightUnit}`}</div>
                );
              },
            }
          : column.accessorKey === "monthly"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const value = `${row.original.monthly ? row.original.monthly : "0"}`;
                const weightUnit = ` ${
                  row.original.weightUnit
                    ? row.original.weightUnit == "Cubic meter"
                      ? "m³"
                      : row.original.weightUnit
                    : "KG"
                }`;
                return (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      level2DataHandler(
                        row.original.unitId,
                        row.original.inventoryNameId,
                        2,
                        row.original.monthlyDate
                      );
                      setTitle("Monthly");
                      return;
                    }}
                  >{`${value} ${weightUnit}`}</div>
                );
              },
            }
          : column.accessorKey === "yearly"
          ? {
              ...column,
              Cell: function customCell({ row }: any) {
                const value = ` ${row.original.yearly ? row.original.yearly : "0"}`;
                const weightUnit = ` ${
                  row.original.weightUnit
                    ? row.original.weightUnit == "Cubic meter"
                      ? "m³"
                      : row.original.weightUnit
                    : "KG"
                }`;
                return (
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      level2DataHandler(
                        row.original.unitId,
                        row.original.inventoryNameId,
                        3,
                        row.original.yearlyDate
                      );
                      setTitle("Yearly");
                      return;
                    }}
                  >{`${value} ${weightUnit}`}</div>
                );
              },
            }
          : column
      );

      setDisplayColumns(transformedColumns);
    }
  }, []);

  const toggleDialog = async () => {
    setIsOpenDailog(!isOpenDailog);
  };

  const handleSearch = () => {
    formik.values.bannedItems ? getInventoryStatusBannedItems() : getInventoryStatus();
  };
  const resetSearch = async () => {
    formik.resetForm();
    setValues(formik.initialValues);
    setResetHandler(true);
  };

  return (
    <>
      <CommonDataGridPage
        module={moduleName}
        heading={pageHeading}
        GridDataComp={
          <CommonMaterialGrid
            rows={gridRecord}
            columns={displayColumns}
            defaultPerPageRecord={15}
            loader={loader}
            height={450}
          />
        }
      >
        <>
          <Grid spacing={6} container direction="row">
            <Grid item xs={12} md={4} lg={4}>
              <FormControlLabel
                control={
                  <Switch
                    checked={Boolean(formik.values.bannedItems)}
                    onChange={formik.handleChange}
                    name="bannedItems"
                    color="primary"
                  />
                }
                label="Seized goods"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonTextFieldDate
                  cssClassName="customTextField"
                  label={"Daily"}
                  name={"daily"}
                  datePickerRef={dailyDatePickerRef}
                  value={formik.values.daily}
                  enableTime={false}
                  onChange={(e: any) => {
                    formik.setFieldValue("daily", moment(e).format("YYYY-MM-DD"));
                  }}
                  maxDate={moment().format("YYYY-MM-DD")}
                  minDate={moment(new Date("2020-01-01")).format("YYYY-MM-DD")}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonTextFieldMonthYear
                  cssClassName="customTextField"
                  label={"Monthly"}
                  name={"monthly"}
                  datePickerRef={monthlyDatePickerRef}
                  value={formik.values.monthly}
                  enableTime={false}
                  onChange={(e: any) => {
                    formik.setFieldValue("monthly", e);
                  }}
                  maxDate={moment().format("YYYY-MM-DD")}
                  minDate={moment(new Date("2020-01-01")).format("YYYY-MM-DD")}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  label="Yearly"
                  // placeholder="Yearly"
                  name="yearly"
                  disableClearable={true}
                  optionsType={yearDate.filter(({ value }: any) => value <= getYear)}
                  getOptionLabel={(option: any) => option.label || null}
                  onChange={(row: any) => {
                    formik.setFieldValue("yearly", row.value);
                  }}
                  value={yearDate.find(({ value }: any) => value == formik.values.yearly) || ""}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <Box>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetSearch()}>
                  Reset
                </CommonButton>
                <CommonButton cssClass="customSubmitBtn" isGreen onClick={() => handleSearch()}>
                  Search
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </>
        <CommonDialog
          isOpen={isOpenDailog}
          handleClose={toggleDialog}
          maxWidth="md"
          heading={`Item Quantity Detail (${title})`}
        >
          <WerehouseLevel2Table />
        </CommonDialog>
      </CommonDataGridPage>
    </>
  );
}
